import type { Language } from "@/hooks/useLanguage";
import type { TermsLegal } from "./types";
import { termsCs } from "./cs";
import { termsEn } from "./en";

export type { TermsLegal, TermsArticle, TermsClause } from "./types";
export {
  TERMS_VERSION,
  TERMS_PUBLISHED_DATE,
  TERMS_EFFECTIVE_DATE,
  termsAcceptance,
} from "./version";

export const termsTranslations: Record<Language, TermsLegal> = {
  cs: termsCs,
  en: termsEn,
};
